import { useAuthUser } from 'react-auth-kit';

const CheckPrivileges = ({ roles = [], children }) => {
  const auth = useAuthUser();

  if (!auth()) return null;

  const userRoles = auth()?.user?.roles?.map((r) => r.name) || [];
  return roles.some((role) => userRoles.includes(role)) ? children : null;
};
export default CheckPrivileges;
